<template>
    <div class="program-info">
        <program-info-content 
            v-if="props.programInfo" 
            :program-name="props.programInfo.programName"
            :channel-call-sign="props.programInfo.channelCallSign"
            :channel-number="props.programInfo.channelNumber"
            :time="props.programInfo.time"
            :description="props.programInfo.description"
            :src-img="props.programInfo.srcImg"
            :advisory-text="props.programInfo.advisoryText"
            :advisory="props.programInfo.advisory"
            :high-definition="props.programInfo.highDefinition"
            :closed-captions="props.programInfo.closedCaptions"
            :descriptive-audio="props.programInfo.descriptiveAudio"
            :is-restart-available="props.programInfo.isRestartAvailable"
        />
        <program-info-skeleton v-else />
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from "vue";
    import type { IProgramInfo } from "@/composables/useProgramInfo/types";
 
    const props = defineProps({
        programInfo: {
            type: (null as unknown) as PropType<IProgramInfo | null>,
            required: true
        }
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>
